const IFRAME_CLASS = 'iframe-container';
const DEFAULT_WIDTH = {
  width: '1px',
  minWidth: '100%'
};
export { IFRAME_CLASS, DEFAULT_WIDTH };
//# sourceMappingURL=constants.js.map